// src/components/NosotrosSection.js
import React from "react";
import "./NosotrosSection.css";
import titleImage1 from "../assets/OmHaus_LOGO.png";
import titleImage2 from "../assets/logo.png";
import titleImage3 from "../assets/e6a.png";
import titleImage4 from "../assets/olivares.png";
import middleImage1 from "../assets/n13.jpg";
import topImage1 from "../assets/n12.jpg";
import bottomImage1 from "../assets/n11.jpg";
import middleImage2 from "../assets/n23.jpg";
import topImage2 from "../assets/n21.jpg";
import bottomImage2 from "../assets/n22.jpg";
import middleImage3 from "../assets/n33.jpg";
import topImage3 from "../assets/n32.jpg";
import bottomImage3 from "../assets/n31.jpg";
import middleImage4 from "../assets/n43.jpg";
import topImage4 from "../assets/n42.jpg";
import bottomImage4 from "../assets/n41.jpg";

const NosotrosSection = () => {
  return (
    <section className="nosotros-section">
      {/* Title Section */}
      <div className="nosotros-title-container">
        <h2 className="nosotros-title">Nosotros</h2>
      </div>

      <div className="nosotros-divider"></div>

      {/* Reusable Subsection 1 */}
      <NosotrosSubsection
        titleImage={titleImage1}
        paragraph={`Om Haus SL es una empresa 
dedicada a la promoción e 
inversión inmobiliaria, enfocada en 
crear viviendas cálidas, funcionales 
y pensadas para el bienestar. Sus 
proyectos ofrecen espacios 
combinando diseño 
contemporáneo, calidad 
constructiva y una integración 
respetuosa con el entorno urbano.
 Con atención al detalle, eficiencia y 
una visión sostenible, acompaña 
cada proyecto desde la idea visión 
original hasta la entrega final, 
garantizando profesionalidad, 
transparencia en proyectos que 
aportan valor real a la ciudad y a 
quienes la habitan.`}
        middleImage={middleImage1}
        topImage={topImage1}
        bottomImage={bottomImage1}
        isFirstSubsection={false}
        middleImageCaption="VENICE Tigre"
        topImageCaption=""
        bottomImageCaption=""
      />

      <NosotrosSubsection
        titleImage={titleImage2}
        paragraph="Compañía de Inversión y 
Desarrollo es una promotora que 
estructura y opera proyectos de 
real estate que mejoran la calidad 
de vida y del trabajo de las 
personas, con responsabilidad, 
creatividad e innovación. 
Cuenta con un equipo de 
profesionales que integran 
disciplinas como Arquitectura, 
Ingeniería Civil, Administración, 
contabilidad y diseño, aportando 
la experiencia de haber 
participado en el desarrollo, 
comercialización y construcción 
de más de 20 proyectos durante 
los últimos 18 años."
        middleImage={middleImage2}
        topImage={topImage2}
        bottomImage={bottomImage2}
        middleImageCaption="ÁTICO Boulevard Labrador"
        topImageCaption="LA VECINDAD Santos Dumont"
        bottomImageCaption="LA VECINDAD Jorge Newbery"
      />

      <NosotrosSubsection
        titleImage={titleImage3}
        paragraph="E6A es un estudio de 
arquitectura especializado en el 
diseño y el desarrollo de 
viviendas unifamiliares premium, 
hoteles y proyectos integrales 
de interiorismo.
 En los últimos 30 años ha 
realizado más de 100 proyectos 
y diseñado más de 50.000 m2 a 
través de una arquitectura de 
calidad y un servicio integral. 
Todo ello asegurando plazos, 
rentabilizando la inversión y 
controlando gastos.
 Con sede en Valencia, su equipo 
acompaña proyectos en todo el 
territorio nacional."
        middleImage={middleImage3}
        topImage={topImage3}
        bottomImage={bottomImage3}
        middleImageCaption="Hotel Filipinas"
        topImageCaption="Villa Zytrus"
        bottomImageCaption="Oficinas EGM"
      />

      <NosotrosSubsection
        titleImage={titleImage4}
        paragraph=" Olivares es una compañía 
dedicada a desarrollar soluciones 
integrales a medida para cualquier 
necesidad inmobiliaria. Su equipo 
combina experiencia y un sólido 
conocimiento del mercado, lo que 
permite evaluar la viabilidad de 
cada iniciativa, identificar las 
oportunidades más convenientes 
y maximizar el valor de los 
activos, tanto en su gestión como 
en procesos de desinversión.
 Con más de veinte años de 
trayectoria, se posiciona de forma 
destacada en los segmentos 
Retail-Comercial, Residencial, 
Suelo, Inversiones e Industrial."
        middleImage={middleImage4}
        topImage={topImage4}
        bottomImage={bottomImage4}
        middleImageCaption="Residencial Atlas"
        topImageCaption="Habitat Mas Camarena II"
        bottomImageCaption="Zamenhof 22"
      />
    </section>
  );
};

// Reusable Subsection Component
// Update the component to accept footnote props
const NosotrosSubsection = ({
  titleImage,
  paragraph,
  middleImage,
  topImage,
  bottomImage,
  isFirstSubsection = false,
  // Add footnote props
  middleImageCaption = "",
  topImageCaption = "",
  bottomImageCaption = "",
  middleImageCaptionFirst = "", // For first subsection's middle image (which becomes bottom-left)
  bottomImageCaptionFirst = "", // For first subsection's bottom image (which becomes bottom-right)
}) => {
  return (
    <div className={`nosotros-subsection ${isFirstSubsection ? "first" : ""}`}>
      <div className="nosotros-subsection-content">
        {/* LEFT */}
        <div className="nosotros-left-col">
          <img src={titleImage} alt="Logo" className="title-image" />
          <p className="nosotros-paragraph">{paragraph}</p>
        </div>

        {/* MIDDLE (hidden on first subsection) */}
        {!isFirstSubsection && (
          <div className="nosotros-middle-col">
            <img src={middleImage} alt="" className="middle-image" />
            {middleImageCaption && (
              <p className="image-caption">{middleImageCaption}</p>
            )}
          </div>
        )}

        {/* RIGHT COLUMN */}
        <div className="nosotros-right-col">
          {isFirstSubsection ? (
            <div className="right-first-layout">
              <div className="image-with-caption">
                <img src={topImage} alt="" className="first-top-image" />
                {topImageCaption && (
                  <p className="image-caption">{topImageCaption}</p>
                )}
              </div>
              <div className="first-bottom-row">
                <div className="image-with-caption">
                  <img src={middleImage} alt="" className="first-bottom-img" />
                  {middleImageCaptionFirst && (
                    <p className="image-caption">{middleImageCaptionFirst}</p>
                  )}
                </div>
                <div className="image-with-caption">
                  <img src={bottomImage} alt="" className="first-bottom-img" />
                  {bottomImageCaptionFirst && (
                    <p className="image-caption">{bottomImageCaptionFirst}</p>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="right-normal-layout">
              <div className="image-with-caption">
                <img src={topImage} alt="" className="right-top-img" />
                {topImageCaption && (
                  <p className="image-caption">{topImageCaption}</p>
                )}
              </div>
              <div className="image-with-caption">
                <img src={bottomImage} alt="" className="right-bottom-img" />
                {bottomImageCaption && (
                  <p className="image-caption">{bottomImageCaption}</p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NosotrosSection;
